import { render, staticRenderFns } from "./PreenchimentoCensoPage.vue?vue&type=template&id=48b93ec6&scoped=true"
import script from "./PreenchimentoCensoPage.vue?vue&type=script&lang=js"
export * from "./PreenchimentoCensoPage.vue?vue&type=script&lang=js"
import style0 from "./PreenchimentoCensoPage.vue?vue&type=style&index=0&id=48b93ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b93ec6",
  null
  
)

export default component.exports